import {getRawBucketByGrade} from "@lib/utils";
import _ from "underscore";
import moment from "moment/moment";

export const formatDateShort = (date: Date) => Intl.DateTimeFormat('default', {  year: 'numeric' , month:  'short' , day: 'numeric' }).format(date);
export const formatDateUrl = (date: Date) => {
    const dateDay = (date.getDate() < 10 ? `0` : ``)+date.getDate();
    const dateMonth = ((date.getMonth()+1) < 10 ? `0` : ``)+(date.getMonth()+1);
    return `${date.getFullYear()}-${dateMonth}-${dateDay}`;
}

export const formatDateTiny = (date: Date) => Intl.DateTimeFormat('default', {  year: '2-digit' , month:  'numeric' , day: 'numeric' }).format(date);
export const formatDateYear = (date: Date | string) => {
    if (typeof date === 'string'){
        return new Date(date).getFullYear();
    }
    return (date as Date).getFullYear();
}

export const formatMoney = (cost: number | string | null, showMovement:boolean=false, forceKeepCents:boolean=false): string => {
    let original = cost === null ? 0 : cost;
    original = (typeof original === 'string') ? Number(original.replace(',','')) : original;
    if(isNaN(original)) return '--';
    if(original === 0) return '--';
    const showCents = forceKeepCents || (original < 1000 && original > -1000);
    return (showMovement ? original > 0 ? '+':'-' : '') + '$'+(original < 0 ? original*-1 : original)
            .toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: (showCents ? 2:0),
                maximumFractionDigits: (showCents ? 2:0)
            });
}

export const formatNumber = (input: string | number | null | undefined): string => {
    if (!!input) {
        const format = Number(input);
        return format.toLocaleString('en-US');
    }
    return '0';
}

export const formatPercent = (percent: number | string | null, isFullNumber: boolean = false): string => {
    let original = (percent === null) ? 0 : percent;
    original = (typeof original === 'string') ? Number(original) : original;
    if(isNaN(original)) return '--';
    if(original === 0) return '--';
    original = !isFullNumber ? original*100 : original;
    const digitsCount = original > 9 ? 0 : 1;
    const fixed = original.toLocaleString('en-US', { minimumFractionDigits: digitsCount, maximumFractionDigits: digitsCount });
    return (original > 0 ? '+' : '') + fixed + '%';
}

export const formatGrade = (grade: number | string | null): string => {
    if(grade === null) return '--';
    const original = (typeof grade === 'string') ? Number(grade) : grade;
    if(isNaN(original)) {
        if(grade === 'NA') return '--';
        return ''+grade;
    }
    if(original === 0) return '--';
    return original < 10 ? original.toFixed(1) : `${original}`;
}

export const formatTitleCase = (str :string, placeholder: string = '') => {
    if(!str) return placeholder;
    return str.replace(/\b[\w']+\b/g, (txt) => {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

export const removeEncodedChars = (str: string) => {
    if(!str) return str;
    return _.unescape(str);
}

export const formatRawBucketGrade = (grade) => {
    if (grade === null) return '--';
    const rawBucket = getRawBucketByGrade(grade) as any;
    if(rawBucket) return (rawBucket.short_desc + " | " + formatGrade(rawBucket.low) + "-" + formatGrade(rawBucket.high));
    return "--";
}

export const getEbayTitleFromIssue = (issue) => {
    const issueDate = moment(issue.date).toDate();
    let strSearch = "";
    if(issue.series_title) {
        const articlePrefixRegex = /, (The|A|An)$/i;
        const articleMatch = issue.series_title.match(articlePrefixRegex);
        if(articleMatch){
            const article = articleMatch[1];
            const baseTitle = issue.series_title.slice(0, -articleMatch[0].length);
            strSearch += `${article} ${baseTitle} `;
        } else {
            strSearch += issue.series_title + ' '
        }
    }
    if(issue.issue_number) strSearch += issue.issue_number + ' ';
    if(issue.variant_name) {
        // Extract the parenthetical content (if any)
        const parenMatch = issue.variant_name.match(/\(([^)]+)\)/);
        const parenItem = parenMatch ? parenMatch[1].trim() : '';

        // Remove the parentheses part from the input
        const withoutParen = issue.variant_name.replace(/\s*\([^)]+\)\s*/, '');

        // Split the remaining items on " - "
        const optionalTerms = withoutParen.split(' - ').map(part => part.trim());

        // Add parent based items (if applicable, "Limited 250")
        if (parenItem) {
            optionalTerms.push(parenItem);
        }

        if(issueDate) optionalTerms.push(issueDate.getFullYear());

        // Join into an optional list of terms for eBay
        const optionalSearchTerms = `(${optionalTerms.join(',')})`;

        strSearch += optionalSearchTerms + ' ';
    }
    return encodeURIComponent(strSearch);
}